export function useWadGTM() {
  const pushGTMValues = (event: string, action?: string) => {
    if (import.meta.server) return

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event,
      action,
      label: window.location.href,
    });
  }

  return { pushGTMValues }
}
